/* eslint-disable */
import React, { useEffect, useState } from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import FadeInSection from "../../../../Components/FadeInSection";
import { useNavigate, useParams } from "react-router-dom";
import axios from "../../../../api/axiosService";
import { sanitize, getLocalized } from "../../../../Common/Util";

// const job = {
//   title: "Account Executive",
//   id: 1,
//   location:
//     "The Global City, đường Đỗ Xuân Hợp, phường An Phú, TP Thủ Đức, TP Hồ Chí Minh",
//   quantity: "01",
//   workTime: "Toàn thời gian (từ thứ Hai đến thứ Sáu)",
//   highlight: true,
//   link: "/jobs/account-executive",

//   companyInfo: {
//     name: "CÔNG TY CỔ PHẦN SPACESPEAKERS LABEL",
//     about:
//       "SpaceSpeakers Label là đơn vị sản xuất & phát hành âm nhạc chuyên nghiệp, trực thuộc SpaceSpeakers Group. Ngoài việc sản xuất và phát hành âm nhạc, SpaceSpeakers Label là môi trường lý tưởng để nuôi dưỡng và hỗ trợ những bạn trẻ có niềm đam mê với âm nhạc.",
//   },

//   objective:
//     "Hỗ trợ Account Leader trong việc triển khai các hợp đồng thương mại, phối hợp với các bộ phận nội bộ để đảm bảo tiến độ và chất lượng thực hiện dự án liên quan đến nghệ sĩ và thương hiệu. Là đầu mối theo dõi thông tin, xử lý giấy tờ và chăm sóc khách hàng trong quá trình thực thi.",

//   responsibilities: [
//     {
//       title: "1. Hỗ trợ triển khai hợp đồng & phối hợp nội bộ:",
//       items: [
//         "Nhận brief từ Account Leader và liên hệ các bộ phận (Creative, Legal, Media, Production…) để triển khai đầu việc.",
//         "Soạn thảo và chuẩn bị các biểu mẫu, hợp đồng, giấy tờ theo quy trình ký kết.",
//         "Theo dõi deadline, gửi nhắc nhở các bên liên quan để đảm bảo tiến độ.",
//       ],
//     },
//     {
//       title: "2. Chăm sóc khách hàng & xử lý công việc phát sinh:",
//       items: [
//         "Làm việc trực tiếp với khách hàng về các đầu việc hàng ngày như gửi proposal, báo giá, chỉnh sửa tài liệu…",
//         "Nhận và phản hồi yêu cầu điều chỉnh nội dung từ khách hàng.",
//         "Ghi chú biên bản họp, tổng hợp feedback và phối hợp xử lý với các bên nội bộ.",
//       ],
//     },
//     {
//       title: "3. Theo dõi và cập nhật tiến độ:",
//       items: [
//         "Lập checklist công việc cho từng dự án, theo dõi tiến trình và báo cáo định kỳ cho Account Leader.",
//         "Đảm bảo các hạng mục như booking, quay chụp, post bài, phê duyệt nội dung… được triển khai đúng timeline.",
//       ],
//     },
//     {
//       title: "4. Hỗ trợ kế toán & giấy tờ hành chính:",
//       items: [
//         "Gửi và theo dõi hóa đơn, hợp đồng scan, thanh toán, đối soát.",
//         "Lưu trữ hồ sơ giấy tờ đúng quy trình của công ty.",
//         "Tổng hợp chi phí phục vụ báo cáo tài chính từng dự án.",
//       ],
//     },
//     {
//       title: "5. Báo cáo & đề xuất cải tiến:",
//       items: [
//         "Hỗ trợ tổng hợp báo cáo sau mỗi chiến dịch.",
//         "Góp ý các điểm cần cải thiện trong quy trình triển khai để tối ưu hiệu quả làm việc nhóm.",
//       ],
//     },
//   ],

//   requirements: [
//     "Từ 1–2 năm kinh nghiệm ở vị trí tương đương hoặc từng làm việc tại agency/media/entertainment là lợi thế.",
//     "Kỹ năng giao tiếp tốt, tư duy logic và khả năng tổ chức công việc chi tiết.",
//     "Biết sử dụng các công cụ văn phòng: Google Workspace, Excel, PowerPoint.",
//     "Ưu tiên ứng viên có hiểu biết về lĩnh vực giải trí, làm việc với brand/Nghệ sĩ/KOL.",
//   ],

//   benefits: [
//     "Mức lương: thỏa thuận theo năng lực",
//     "Thưởng theo dự án.",
//     "Môi trường làm việc về lĩnh vực giải trí, trẻ trung, năng động.",
//     "Tham gia các sự kiện của công ty.",
//     "Chính sách phúc lợi theo quy định của Nhà nước.",
//   ],

//   applicationInfo: {
//     email: "hr@spacespeakers.vn",
//     emailTitle: "SSL - HỌ VÀ TÊN - VỊ TRÍ ỨNG TUYỂN",
//     instruction:
//       "Ứng viên gửi CV & Portfolio (nếu có) qua: hr@spacespeakers.vn",
//   },
// };

function CareerDetail() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [job, setJob] = useState({});
  let pId = useParams().id;

  const getJobInfo = async () => {
    try {
      const response = await axios.get(`/api/career/info?id=${pId}`);
      setJob(response.data.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const backToJobList = () => {
    navigate(`/ssl-carreer`);
  };

  useEffect(() => {
    getJobInfo();
  }, []);

  const handleApply = () => {
    const subject = encodeURIComponent(
      getLocalized(job.applicationInfo, "emailTitle", i18n.language) ||
        job.applicationInfo?.emailTitle,
    );
    const body = encodeURIComponent(`Kính gửi HR Team SpaceSpeakers Label,

Tôi xin gửi đến Quý công ty hồ sơ ứng tuyển cho vị trí ${getLocalized(job, "title", i18n.language)}.

Trân trọng,`);

    window.location.href = `mailto:${job.applicationInfo.email}?subject=${subject}&body=${body}`;
  };

  return (
    <div className="career-ssl min-h-screen px-4 font-sans">
      <div className="header-ssl-career">
        <div className="back-to-list normal-text" onClick={backToJobList}>
          <button>
            <ion-icon
              name="chevron-back-outline"
              className="icon"
              size="large"
            ></ion-icon>{" "}
            NGHỀ NGHIỆP
          </button>
        </div>
        <h1 className="carreer-title title-1 global-title-margin uppercase">
          {getLocalized(job, "title", i18n.language)}
        </h1>
      </div>

      <div className="job-detail-content">
        <FadeInSection>
          <div className="company-info mb-8">
            <h2 className="section-title text-2xl font-bold mb-4 primary-color">
              THÔNG TIN CÔNG TY
            </h2>
            <div className="mb-4">
              <p className="text-gray-700">
                <strong>Tên công ty:</strong>{" "}
                {getLocalized(job.companyInfo, "name", i18n.language)}
              </p>
              <p className="text-gray-700">
                <strong>Địa điểm:</strong>{" "}
                {getLocalized(job, "location", i18n.language)}
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-lg mb-2">Về chúng tôi:</h3>
              <p className="text-gray-700 leading-relaxed">
                {getLocalized(job.companyInfo, "about", i18n.language)}
              </p>
            </div>
          </div>
        </FadeInSection>

        <FadeInSection>
          <div className="position-info mb-8">
            <h2 className="section-title text-2xl font-bold mb-4 primary-color">
              VỊ TRÍ
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <p className="text-gray-700">
                <strong>Tên vị trí:</strong>{" "}
                {getLocalized(job, "title", i18n.language)}
              </p>
              <p className="text-gray-700">
                <strong>Số lượng:</strong> {job.quantity}
              </p>
              <p className="text-gray-700 md:col-span-2">
                <strong>Thời gian:</strong>{" "}
                {getLocalized(job, "workTime", i18n.language)}
              </p>
            </div>
          </div>
        </FadeInSection>

        <FadeInSection>
          <div className="job-objective mb-8">
            <h2 className="section-title text-2xl font-bold mb-4 primary-color">
              MỤC TIÊU CÔNG VIỆC
            </h2>
            <p className="text-gray-700 leading-relaxed">
              {getLocalized(job, "objective", i18n.language)}
            </p>
          </div>
        </FadeInSection>

        <FadeInSection>
          <div className="job-responsibilities mb-8">
            <h2 className="section-title text-2xl font-bold mb-4 primary-color">
              Mô Tả Công Việc
            </h2>
            <div
              className="description normal-text"
              dangerouslySetInnerHTML={sanitize(
                getLocalized(job, "jobDes", i18n.language),
              )}
            />
          </div>
        </FadeInSection>

        <FadeInSection>
          <div className="application-process mb-8">
            <h2 className="section-title text-2xl font-bold mb-4 primary-color">
              HÌNH THỨC NỘP CV
            </h2>
            <p className="text-gray-700 leading-relaxed mb-2">
              {getLocalized(job.applicationInfo, "instruction", i18n.language)}
            </p>
            <p className="text-gray-700">
              <strong>Tiêu đề email:</strong>{" "}
              {getLocalized(job.applicationInfo, "emailTitle", i18n.language)}
            </p>
          </div>
        </FadeInSection>
      </div>
    </div>
  );
}

export default CareerDetail;
